// Emoji names come from emoji-picker-react's bundled English data, loaded on first use so
// they're not part of the main bundle.
const MAX_EMOJI_VERSION = 14; // Skip very new emoji that older phones can't display.

let indexPromise = null;

const toEmoji = (unified) => String.fromCodePoint(...unified.split('-').map((hex) => parseInt(hex, 16)));

const buildIndex = (data) => {
  const groups = Object.values(data?.emojis || {});
  return groups.flat()
    .filter((entry) => entry?.u && Array.isArray(entry.n) && parseFloat(entry.a || '0') <= MAX_EMOJI_VERSION)
    .map((entry) => ({
      emoji: toEmoji(entry.u),
      name: entry.n[entry.n.length - 1],
      keywords: entry.n.map((n) => n.toLowerCase()),
    }));
};

export const loadEmojiIndex = () => {
  if (!indexPromise) {
    indexPromise = import('emoji-picker-react/dist/data/emojis-en.json')
      .then((module) => buildIndex(module.default || module))
      .catch((err) => {
        indexPromise = null;
        throw err;
      });
  }
  return indexPromise;
};

// Exposed for tests.
export const _resetEmojiIndex = () => { indexPromise = null; };

/** Ranks emoji whose name or keywords start with (then contain) the query. */
export const searchEmojiIndex = (index, query, limit = 6) => {
  const q = (query || '').toLowerCase().replace(/_/g, ' ').trim();
  if (q.length < 2) return [];
  const scored = [];
  index.forEach((item) => {
    const name = item.name.toLowerCase();
    let score = null;
    if (name === q) score = 0;
    else if (name.startsWith(q)) score = 1;
    else if (item.keywords.some((k) => k === q)) score = 2;
    else if (item.keywords.some((k) => k.startsWith(q))) score = 3;
    else if (name.includes(q)) score = 4;
    if (score !== null) scored.push({ item, score });
  });
  scored.sort((a, b) => a.score - b.score || a.item.name.length - b.item.name.length);
  return scored.slice(0, limit).map((s) => s.item);
};

/**
 * If the text before the caret ends with a `:shortcode` (2+ characters), returns the query and
 * where it starts so the caller can replace it with the chosen emoji.
 */
export const getShortcodeQuery = (value, caret) => {
  const before = (value || '').slice(0, caret);
  const match = before.match(/(^|\s):([a-z0-9_+-]{2,30})$/i);
  if (!match) return null;
  return { query: match[2], start: caret - match[2].length - 1 };
};
